import { apiClient } from 'api/client/apiClient';
import { ProjectDTO } from '../types';
import { API_URLS } from '../consts';

export const fetchProjects = async () => {
  const result = await apiClient.get<ProjectDTO[]>(`${API_URLS.ProjectManagementSystem}/projects`);

  return result.data;
};
